module.exports = __webpack_public_path__ + "static/media/chevromRight.5f498235.svg";